export { default as NotFoundPage } from './NotFoundPage'
export { default as SignInPage } from './SignInPage'
export { default as SignUpPage } from './SignUpPage'
export { default as SignOutPage } from './SignOutPage'
export { default as AuthorizedPage } from './AuthorizedPage'
export { default as LessonDetailPage } from './LessonDetailPage'
export { default as LessonInstagramPage } from './LessonInstagramPage'
export { default as PexesoPage } from './PexesoPage'
export { default as CrosswordPage } from './CrosswordPage'
export { default as LessonsPage } from './LessonsPage'
export { default as TestPage } from './TestPage'
export { default as TestsPage } from './TestsPage'
export { default as HomeworksPage } from './HomeworksPage'
export { default as GroupsPage } from './GroupsPage'
export { default as UserPage } from './UserPage'
export { default as StudentPage } from './StudentPage'
export { default as GroupDetailPage } from './GroupDetailPage'
export { default as TestDetailPage } from './TestDetailPage'
export { default as TranslationFormPage } from './TranslationFormPage'
export { default as WordboxFormPage } from './WordboxFormPage'
export { default as OptionsFormPage } from './OptionsFormPage'
export { default as OpenQuestionFormPage } from './OpenQuestionFormPage'
export { default as CreateLessonPage } from './CreateLessonPage'
export { default as TestFormPage } from './TestFormPage'
export { default as HomeworkFormPage } from './HomeworkFormPage'
export { default as GroupFormPage } from './GroupFormPage'
export { default as SearchPage } from './SearchPage'
export { default as ChangePasswordPage } from './ChangePasswordPage'
export { default as ForgottenPasswordPage } from './ForgottenPasswordPage'
export { default as SetLanguagesPage } from './SetLanguagesPage'
export { default as TutorialPage } from './TutorialPage'
export { default as StaticPage } from './StaticPage'
export { default as StaticPageTestUpload } from './StaticPageTestUpload'
export { default as FollowersPage } from './FollowersPage'
export { default as ResultPage } from './ResultPage'
export { default as ResultsPage } from './ResultsPage'
export { default as StudentResultsPage } from './StudentResultsPage'
export { default as AdminPage } from './admin/AdminPage'
export { default as LocalizationPage } from './admin/LocalizationPage'
export { default as HomeworkDetailPage } from './HomeworkDetailPage'
export { default as PrivacyPolicyPage } from './PrivacyPolicyPage'
export { default as WelcomePage } from './WelcomePage'
export { default as VocabularyLearnPage } from './VocabularyLearnPage'
export { default as SubscribePage } from './SubscribePage'
export { default as FirstListPage } from './FirstListPage'
export { default as FirstListLearnPage } from './FirstListLearnPage'
export { default as OnboardingPage } from './OnboardingPage'
export { default as FirstTestPage } from './FirstTestPage'
export { default as StudentLandingPage } from './StudentLandingPage'
export { default as VideosPage } from './VideosPage'
export { default as VideosProfilePage } from './VideosProfilePage'

/* grammar */
export { default as LanguagesGrammarPage } from './grammar/LanguagesGrammarPage'
export { default as LanguageGrammarRulesListPage } from './grammar/LanguageGrammarRulesListPage'
export { default as LanguageGrammarRuleDetailPage } from './grammar/LanguageGrammarRuleDetailPage'



// WEBPACK FOOTER //
// ./src/browser/pages/index.js